import { render, staticRenderFns } from "./TableBanner.vue?vue&type=template&id=7978e953&scoped=true&lang=pug"
import script from "./TableBanner.vue?vue&type=script&lang=ts"
export * from "./TableBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978e953",
  null
  
)

export default component.exports